let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bIh6w")).then(() => parcelRequire('9iT7G'));